import { stringifyQs } from "@saleor/utils/urls";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  //   FiltersWithMultipleValues,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const MallOrdersSection = "/reports/bi/mall-orders";

export const MallOrdersListPath = MallOrdersSection;

export enum MallOrdersListUrlFiltersEnum {
  orderCompleteDateFrom = "orderCompleteDateFrom",
  orderCompleteDateTo = "orderCompleteDateTo",
  query = "query"
}

export type MallOrdersListUrlDialog = "download" | TabActionDialog;
export type MallOrdersListUrlFilters = Filters<MallOrdersListUrlFiltersEnum>;

export type MallOrdersUrlQueryParams = ActiveTab &
  MallOrdersListUrlFiltersEnum &
  BulkAction &
  Dialog<MallOrdersListUrlDialog> &
  Pagination &
  SingleAction;

export const mallOrdersListUrl = (params?: MallOrdersUrlQueryParams) =>
  MallOrdersListPath + "?" + stringifyQs(params);
